import user from "./user";
import order from "./order";
import activity from "./activity";

export default [...user, ...order, ...activity];
